/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.big-icon {
  display: inline-flex;
  padding: var(--cpd-space-4x);
  border-radius: var(--cpd-space-2x);

  > svg {
    inline-size: 32px;
    block-size: 32px;
  }
}

.big-icon[data-size="md"] {
  padding: var(--cpd-space-3x);
}

.big-icon[data-size="sm"] {
  padding: var(--cpd-space-3x);

  > svg {
    inline-size: 24px;
    block-size: 24px;
  }
}

.big-icon[data-kind="primary"] {
  background-color: var(--cpd-color-bg-subtle-secondary);
  color: var(--cpd-color-icon-primary);
}

.big-icon[data-kind="critical"] {
  background-color: var(--cpd-color-bg-critical-subtle);
  color: var(--cpd-color-icon-critical-primary);
}

.big-icon[data-kind="success"] {
  background-color: var(--cpd-color-bg-success-subtle);
  color: var(--cpd-color-icon-success-primary);
}

@media (forced-colors: active) {
  .big-icon {
    outline: 1px solid transparent;
  }
}
